import { ISkippedClause } from "@/api";
import { Table } from "@/components/shared/table/Table";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

interface IProps {
    skippedClauses: ISkippedClause[];
}

const columns: GridColDef<ISkippedClause>[] = [
    {
        field: "row_number",
        headerName: "Row Number",
        flex: 1,
        maxWidth: 120,
        sortable: false,
    },
    {
        field: "reason",
        headerName: "Reason",
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: (params) => {
            return (
                <Stack direction="row" alignItems="center" gap={1}>
                    <TextSnippetIcon color="primary" fontSize="small" />
                    <Typography variant="body2" color="text.secondary">
                        {params.value}
                    </Typography>
                </Stack>
            );
        },
    },
];

export const SkippedClausesList = ({ skippedClauses }: IProps) => {
    return (
        <Card variant="outlined">
            <CardHeader title="Skipped Clauses Details" />

            <CardContent>
                <Table
                    rows={skippedClauses}
                    columns={columns}
                    getRowId={(row) => row.row_number}
                    disableColumnMenu
                />
            </CardContent>
        </Card>
    );
};
